export default __webpack_public_path__ + "static/media/photo--sm--33.34220751.jpg";